class StickySidebar {
	constructor() {
		this.$stickySidebars = document.querySelector(
			'.component-sticky-sidebar'
		);
		this.stickOffset = 140;
		document
			.querySelector(':root')
			.style.setProperty('--sticky-sidebar-top', this.stickOffset + 'px');
		if (this.$stickySidebars && this.$stickySidebars.length > 0) {
			this.sidebarHeight = this.$stickySidebars.offsetHeight;
			this.sidebarContainerHeight =
				this.$stickySidebars.parentNode.offsetHeight;
			this.stickTop =
				this.getCoords(this.$stickySidebars.parentNode).top -
				this.stickOffset;
			this.stickBottom = this.stickTop + this.sidebarContainerHeight;
		}
	}
	getPositions() {
		if (this.$stickySidebars && this.$stickySidebars.length > 0) {
			this.sidebarHeight = this.$stickySidebars.offsetHeight;
			this.sidebarContainerHeight =
				this.$stickySidebars.parentNode.offsetHeight;
			this.stickTop =
				this.getCoords(this.$stickySidebars.parentNode).top -
				this.stickOffset;
			this.stickBottom = this.stickTop + this.sidebarContainerHeight;
		}
	}
	changeSidebarClasses() {
		if (this.$stickySidebars && this.$stickySidebars.length > 0) {
			if (
				window.scrollY >= this.stickTop &&
				window.scrollY + this.sidebarHeight <= this.stickBottom
			) {
				this.$stickySidebars.classList.remove(
					'component-sticky-sidebar--top'
				);
				this.$stickySidebars.classList.remove(
					'component-sticky-sidebar--bottom'
				);
				this.$stickySidebars.classList.add(
					'component-sticky-sidebar--fixed'
				);
			} else {
				this.$stickySidebars.classList.remove(
					'component-sticky-sidebar--fixed'
				);
				if (window.scrollY < this.stickTop) {
					this.$stickySidebars.classList.add(
						'component-sticky-sidebar--top'
					);
				} else {
					this.$stickySidebars.classList.add(
						'component-sticky-sidebar--bottom'
					);
				}
			}
		}
	}
	getCoords(elem) {
		const box = elem.getBoundingClientRect();

		const body = document.body;
		const docEl = document.documentElement;

		const scrollTop =
			window.pageYOffset || docEl.scrollTop || body.scrollTop;
		const scrollLeft =
			window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

		const clientTop = docEl.clientTop || body.clientTop || 0;
		const clientLeft = docEl.clientLeft || body.clientLeft || 0;

		const top = box.top + scrollTop - clientTop;
		const left = box.left + scrollLeft - clientLeft;

		return { top: Math.round(top), left: Math.round(left) };
	}
}

const newStickySidebar = new StickySidebar();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newStickySidebar.getPositions();
	},
	loaded() {
		newStickySidebar.getPositions();
	},
	resized() {
		newStickySidebar.getPositions();
	},
	scrolled() {
		newStickySidebar.changeSidebarClasses();
	},
	keyDown() {},
	mouseUp() {},
};
export default controller;
